export default __webpack_public_path__ + "static/wood2-794b2ed13bc9fd61f57b5816a838b09e.png";